export interface Employee {
  id?: string | null;
  firstname: string;
  lastname: string;
  email: string | null;
  phoneNumber: string | null;
  title: PersonTitle;
  birthName: string | null;
  birthdate: string | null;
  birthplace: string | null;
  birthCountry: string | null;
  socialSecurityNumber: string | null;
  address: string | null;
  additionalAddress: string | null;
  postalCode: string | null;
  city: string | null;
  nationality: string | null;
}
export type PersonTitle = 'Monsieur' | 'Madame';
export const PersonTitles: PersonTitle[] = ['Monsieur', 'Madame'];
